
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/items/[[...slug]]",
      function () {
        return require("private-next-pages/info/items/[[...slug]].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/items/[[...slug]]"])
      });
    }
  